import {
  Component,
  Input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { KostDataImportProcessDataDe } from '../../import-process';
import { FormsModule } from '@angular/forms';
import { CheckboxChangeEvent, CheckboxModule } from 'primeng/checkbox';
import { BdFeaturePermissionCheckerComponent } from '@bindoc-projects/bindoc-permissions-lib/ui';
import { BdUiSaltInputComponent } from '@bindoc-projects/salt-lib/ui';
import { Message } from 'primeng/message';

@Component({
  selector: 'kost-data-import-de-new-parameters-anonymization',
  template: `
    <div class="section">
      <div>
        <span class=""
          >Wählen Sie aus welche optionalen Daten gespeichert werden sollen (Die
          Auswahl kann den Detailgrad von Analysen auf dem Datensatz
          beeinflussen)</span
        >
      </div>
      <div class="">
        <div class="flex flex-row gap-2">
          <p-checkbox
            [ngModel]="processData.parameters.anonymization.p21Case.postalCode"
            [binary]="true"
            (onChange)="onPostalCodeFieldChange($event)"
          ></p-checkbox>
          <div>Postleitzahl Patientenherkunft</div>
        </div>
        @if (!processData.parameters.anonymization.p21Case.postalCode) {
          <p-message severity="warn" variant="simple"
            >Ein Datensatz ohne Postleitzahlen vermindertet die
            Analyse-Genauigkeit
          </p-message>
        }
      </div>

      <bd-feature-permission-checker [permissions]="permissions">
        <div class="flex flex-row gap-2">
          <p-checkbox
            [ngModel]="
              processData.parameters.anonymization.p21Case.randomizeInternMark
            "
            [binary]="true"
            (onChange)="onRandomizeInternMark($event)"
          >
          </p-checkbox>
          <div>Fallnummern anonymisieren</div>
        </div>
      </bd-feature-permission-checker>
    </div>

    <div class="section">
      <bd-ui-salt-input
        [salt]="processData.parameters.anonymization.salt"
        (saltChange)="onSaltChange($event)"
      />
    </div>
  `,
  styles: `
    .section {
      margin: 12px 0;
    }
  `,

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
    CheckboxModule,
    BdFeaturePermissionCheckerComponent,
    BdUiSaltInputComponent,
    Message,
  ],
})
export class KostDataImportDeNewParametersAnonymizationComponent {
  @Input()
  public processData: KostDataImportProcessDataDe;

  public readonly update = output<{
    data: KostDataImportProcessDataDe;
    complete: boolean;
  }>();

  public readonly permissions: `${string}:${string}`[] = [
    'VIRTUAL_CLINIC_P21:RANDOMIZE_INTERN_MARK',
  ];

  public onRandomizeInternMark(event: CheckboxChangeEvent): void {
    console.log(this.processData.parameters.anonymization);
    console.log(event);
    this.processData.parameters.anonymization.p21Case.randomizeInternMark =
      event.checked;

    this._emitUpdate();
  }

  public onPostalCodeFieldChange(event: CheckboxChangeEvent): void {
    this.processData.parameters.anonymization.p21Case.postalCode =
      event.checked;

    this._emitUpdate();
  }

  public onSaltChange(salt: string): void {
    this.processData.parameters.anonymization.salt = salt;

    this._emitUpdate();
  }

  private _emitUpdate(): void {
    this.update.emit({
      data: this.processData,
      complete: this._isComplete(),
    });
  }

  private _isComplete(): boolean {
    return (
      typeof this.processData.parameters.anonymization.salt === 'string' &&
      this.processData.parameters.anonymization.salt.length > 0
    );
  }
}
